import { Checkbox, Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import ModalLayout from "../ModalLayout";
import { useGlobalData } from "@/contexts/GlobalData";
import Image from "next/image";
import styles from "./index.module.css";
import { cn } from "@/lib/utils";
import DynamicFontSize from "../DynamicFontSize";
import GradientButton from "../GradientButton";
import UnderlineText from "../UnderlineText";
import { useAuth } from "@/contexts/Auth";
import updateAnnoucementService from "@/services/updateAnnoucementService";
import { useRouter } from "next/navigation";
import DynamicSizeIcon from "../DynamicSizeIcon";
import openLinkInTelegram from "@/utils/openLinkInTelegram";
import { useClickAway } from "@uidotdev/usehooks";
import { CheckboxPrimary } from "../CheckboxPrimary";
function GeneralPopup() {
  const prefix = "general_popup_";
  const {
    translate,
    getImageFromCMS,
    announcementData,
    setAnnouncementData,
    getIcon,
    setOverriedOpen,
    overriedOpen
  } = useGlobalData();
  const {
    token
  } = useAuth();
  const router = useRouter();
  const [isOpen, setOpen] = useState(false);
  const [statusButton, setStatusButton] = useState("normal");
  const [isChecked, setIsChecked] = useState(false);
  const ref = useClickAway<any>(() => {
    setOpen(false);
    setOverriedOpen && setOverriedOpen(false);
  });
  const handleUpdateAnnouncement = (isSelected: boolean) => {
    setIsChecked(isSelected);
    if (announcementData?.data?.readed || !isSelected) {
      return;
    }
    try {
      updateAnnoucementService(announcementData?.data?.id, token, res => {
        if (res?.status == "success") {
          setAnnouncementData((prev: any) => {
            return {
              ...prev,
              data: {
                ...prev.data,
                readed: true
              }
            };
          });
        }
      });
    } catch (error) {
      console.log("🚀 ~ handleUpdateAnnouncement ~ error:", error);
    }
  };
  const handleOpenLink = () => {
    if (announcementData?.data?.link?.includes("https://")) {
      setOpen(false);
      setOverriedOpen && setOverriedOpen(false);
      openLinkInTelegram(announcementData?.data?.link);
      return;
    }
    setOpen(false);
    setOverriedOpen && setOverriedOpen(false);
    return router.push(announcementData?.data?.link);
  };
  useEffect(() => {
    if (announcementData) {
      if (!announcementData?.data?.readed && announcementData?.haveAnnounce) {
        return setOpen(true);
      }
      return setOpen(false);
    }
  }, [announcementData]);
  useEffect(() => {
    setIsChecked(announcementData?.data?.readed || false);
  }, [overriedOpen, announcementData]);
  return <Modal isOpen={(overriedOpen || isOpen) && announcementData?.haveAnnounce} onOpenChange={setOpen} isDismissable={false} hideCloseButton backdrop="blur" size="full" data-sentry-element="Modal" data-sentry-component="GeneralPopup" data-sentry-source-file="index.tsx">
            <ModalContent className={cn("rounded-none bg-transparent px-[38px] flex flex-col justify-center", styles.bg_general_popup)} data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                <div className="flex flex-col gap-4 relative w-full h-full max-h-[400px] justify-center items-center" ref={ref}>
                    <div className="flex flex-col items-center text-center z-10 absolute top-5 gap-4 w-full">
                        <DynamicFontSize fontSize={24} className={cn("leading-[1.2] uppercase font-semibold text-white max-w-[238px]", styles.text_shadow)} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                            <p className="revert-tailwind" dangerouslySetInnerHTML={{
              __html: announcementData?.data?.title || ""
            }} />
                        </DynamicFontSize>
                        <DynamicFontSize fontSize={16} className={cn("leading-[1.2] text-white max-w-[280px]", styles.text_shadow)} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                            <p className="revert-tailwind" dangerouslySetInnerHTML={{
              __html: announcementData?.data?.description || ""
            }} />
                        </DynamicFontSize>
                        <GradientButton onClick={handleOpenLink} className="w-fit min-w-[150px] items-center flex gap-2 justify-center mt-1" status={statusButton} data-sentry-element="GradientButton" data-sentry-source-file="index.tsx">
                            <span>{translate("general_popup_button")}</span>
                            <DynamicSizeIcon width={20} icon={getIcon("announce_explore")} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
                        </GradientButton>
                    </div>
                    <Image src={announcementData?.data?.image || getImageFromCMS("general_popup")} alt="general_popup" fill objectFit="cover" className="rounded-2xl" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
                    <div className={cn("absolute w-full h-full inset-0 rounded-2xl", styles.bg_general_popup)}></div>
                    <div className="flex flex-col gap-1.5 items-center absolute top-[calc(100%+10px)] left-1/2 -translate-x-1/2">
                        {/* <PrimaryButton
                         onClick={handleOpenLink}
                         className="w-full min-w-[200px]"
                         status={statusButton}
                         >
                         {translate("general_popup_button")}
                         </PrimaryButton> */}
                        {/* <div className="flex items-center gap-1">
                         <Checkbox
                         isSelected={isChecked}
                         onValueChange={handleUpdateAnnouncement}
                         color="secondary"
                         radius="sm"
                         size="lg"
                         classNames={{ label: "leading-none", base: "!size-6 flex-1" }}
                         ></Checkbox>
                         <UnderlineText className="text-xs leading-[1.5]">
                         {translate("general_popup_checkbox")}
                         </UnderlineText>
                         </div> */}
                        <CheckboxPrimary isSelected={isChecked} onValueChange={handleUpdateAnnouncement} data-sentry-element="CheckboxPrimary" data-sentry-source-file="index.tsx">
                            <UnderlineText className="text-xs leading-[1.5]" data-sentry-element="UnderlineText" data-sentry-source-file="index.tsx">
                                {translate("general_popup_checkbox")}
                            </UnderlineText>
                        </CheckboxPrimary>
                    </div>
                    <div className="z-10 absolute right-0 bottom-full -translate-y-[3px] flex items-center gap-1 cursor-pointer" onClick={() => {
          setOpen(false);
          setOverriedOpen && setOverriedOpen(false);
        }}>
                        <DynamicFontSize fontSize={13} className="text-white" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                            {translate("general_popup_close")}
                        </DynamicFontSize>
                        <DynamicSizeIcon icon={getIcon(prefix + "close")} width={18} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
                    </div>
                </div>
            </ModalContent>
        </Modal>;
}
export default GeneralPopup;